import fp from 'lodash/fp';

export class Field {
    static UNFILLED_BACKGROUND = 'lightyellow';
    static TOOLS = {};

    static fromFieldData(fieldData, options) {
        const FieldClass = Field.TOOLS[fieldData.type];
        const fld = new FieldClass(fp.cloneDeep(fieldData), options);
        return fld;
    }

    constructor(data, options) {
        this.data = data;
        this.pageController = options.pageController;
    }

    get progressLabel() {
        return 'Next';
    }

    draw() {
        // override
    }

    click(/*ev, element*/) {
        // override
    }

    get filled() {
        return this.data.filled;
    }

    set filled(value) {
        this.data.filled = value;
        this.pageController.formController.countIncomplete();
    }

    _postClick(ev, newEl, canvas) {
        if (this.data.filled) {
            this.pageController.handleClickNext(newEl);
        } else {
            this.pageController.setCurrent(newEl);
            canvas.setActiveObject(newEl);
        }
        return newEl;
    }

    set(el, settings) {
        el.set({field: this, ...settings});
        this.data.field_data.elProps = fp.merge(
            this.data.field_data.elProps,
            settings,
        );
    }

    scaleElement(oldEl, newEl, {useMax = true}) {
        // Proportionally scale element to barely fit in field box
        if (!oldEl?.width) return newEl;
        const scaleX = (oldEl.width * oldEl.scaleX) / newEl.width;
        const scaleY = (oldEl.height * oldEl.scaleY) / newEl.height;
        const scale = useMax
            ? Math.max(scaleX, scaleY)
            : Math.min(scaleX, scaleY);
        this.set(newEl, {scaleX: scale, scaleY: scale});
        return newEl;
    }

    toJSON(/*el*/) {
        return {
            id: this.data.id,
            value: this.data.value,
            type: this.data.type,
            filled: this.data.filled,
        };
    }
}
